export default "__VITE_ASSET__0faae217__"